export interface HorizontalGesture {
  distance: number;
  progress: number;
  committed: boolean;
}

export function horizontalGesture(deltaX: number, deltaY: number, width: number, direction: -1 | 1, threshold = .28, velocity = 0): HorizontalGesture {
  const directed = Math.max(0, deltaX * direction);
  const distance = Math.min(Math.max(0, width), directed);
  const horizontal = directed > Math.abs(deltaY) * 1.2;
  const progress = width > 0 ? distance / width : 0;
  return { distance, progress, committed: horizontal && (progress >= threshold || progress >= .08 && velocity >= .45) };
}

export function edgeAutoScroll(pointerY: number, top: number, bottom: number, edge = 56, maximum = 14): number {
  if (pointerY < top + edge) return -maximum * Math.min(1, (top + edge - pointerY) / edge);
  if (pointerY > bottom - edge) return maximum * Math.min(1, (pointerY - (bottom - edge)) / edge);
  return 0;
}
